var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 72.3332H114.833V63.9998C114.833 52.4998 105.5 43.1665 94 43.1665C82.5 43.1665 73.1667 52.4998 73.1667 63.9998V72.3332H69C64.4167 72.3332 60.6667 76.0832 60.6667 80.6665V122.333C60.6667 126.917 64.4167 130.667 69 130.667H119C123.583 130.667 127.333 126.917 127.333 122.333V80.6665C127.333 76.0832 123.583 72.3332 119 72.3332ZM94 109.833C89.4167 109.833 85.6667 106.083 85.6667 101.5C85.6667 96.9165 89.4167 93.1665 94 93.1665C98.5834 93.1665 102.333 96.9165 102.333 101.5C102.333 106.083 98.5834 109.833 94 109.833ZM106.917 72.3332H81.0834V63.9998C81.0834 56.8748 86.875 51.0832 94 51.0832C101.125 51.0832 106.917 56.8748 106.917 63.9998V72.3332Z",
    fill: "#CBCCCC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 92,
    stroke: "#CBCCCC",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedImg);
export default __webpack_public_path__ + "static/media/restricted_img.922f99c338780a48cf5837cadd12dca1.svg";
export { ForwardRef as ReactComponent };